const navigation = [
	{
		id: 'applications',
		title: 'Applications',
		translate: 'Navigation',
		type: 'group',
		icon: 'apps',
		children: [
			{
				id: 'Dashboard',
				title: 'Dashboard',
				translate: 'Dashboard',
				type: 'item',
				icon: 'dashboard',
				url: '/apps/dashboard',
				exact: true
			},
			{
				id: 'companyprofile',
				title: 'Company Profile',
				translate: 'Business',
				type: 'item',
				icon: 'dashboard',
				url: '/apps/company-profile',
				exact: true
			},
			{
				id: 'dashboards',
				title: 'Intelligence',
				translate: 'Intelligence',
				type: 'item',
				image: '/assets/images/icons/Sidebar/dashboard.png',
				url: '/dashboard',
				exact: true
			},
			{
				id: 'Opt',
				title: 'OPT',
				translate: 'Opt',
				type: 'item',
				icon: 'dashboard',
				url: '/apps/opt',
				exact: true
			},
			{
				id: 'OptReport',
				title: 'OPT Report',
				translate: 'Opt Report',
				type: 'item',
				icon: 'dashboard',
				url: '/apps/optReport',
				exact: true
			},
			{
				id: 'Chat',
				title: 'Chat',
				translate: 'Chat',
				type: 'collapse',
				image: '/assets/images/icons/Sidebar/chat.png',
				children: [
					{
						id: 'Conversation',
						title: 'Conversation',
						translate: 'Conversation',
						type: 'item',
						url: '/apps/chat',
						exact: true
					},
					{
						id: 'Agent_Conversation',
						title: 'Ongoing Chats',
						translate: 'Ongoing Chats',
						type: 'item',
						url: '/apps/ongoing',
						exact: true
					}
				]
			},
			{
				id: 'Inbox',
				title: 'Inbox',
				translate: 'Inbox',
				type: 'collapse',
				image: '/assets/images/icons/Sidebar/ticket.png',
				children: [
					{
						id: 'ConversationT',
						title: 'Tickets',
						translate: 'Tickets',
						type: 'item',
						url: '/apps/inbox',
						exact: true
					},
					{
						id: 'HistoryT',
						title: 'Ticket History',
						translate: 'Ticket History',
						type: 'item',
						url: '/apps/ticket-history',
						exact: true
					},
					{
						id: 'ongoingT',
						title: 'Ongoing Tickets',
						translate: 'Ongoing Tickets',
						type: 'item',
						url: '/apps/ticket-ongoing',
						exact: true
					},
					{
						id: 'History',
						title: 'Overall History',
						translate: 'Overall History',
						type: 'item',
						url: '/apps/history',
						exact: true
					},
					{
						id: 'TicketsReport',
						title: 'Ticket Reports',
						translate: 'Ticket Reports',
						type: 'item',
						url: '/apps/report/ticket',
						exact: true
					},
					{
						id: 'TicketsComplain',
						title: 'Tickets Complain',
						translate: 'Tickets Complain',
						type: 'item',
						url: '/apps/complain/ticket',
						exact: true
					},
					{
						id: 'Complain Tickets Report',
						title: 'Complain Tickets Report',
						translate: 'Complain Tickets Report',
						type: 'item',
						url: '/report/complain-tickets-report',
						exact: true
					},
					{
						id: 'Call History',
						title: 'Call History',
						translate: 'Call History',
						type: 'item',
						url: '/apps/call-history',
						exact: true
					}
				]
			},
			{
				id: 'Template Messages New',
				title: 'Template Messages',
				translate: 'Template Messages',
				type: 'collapse',
				image: '/assets/images/icons/Sidebar/template.png',
				children: [
					{
						id: 'API Outbox',
						title: 'API Outbox',
						translate: 'API Outbox',
						type: 'item',
						url: '/template-messages/api-outbox',
						exact: true
					},
					{
						id: 'Campaign Management',
						title: 'Campaign Management',
						translate: 'Campaign Management',
						type: 'item',
						url: '/template-messages/campaign-management',
						exact: true
					},
					{
						id: 'Account Summary',
						title: 'Account Summary',
						translate: 'Account Summary',
						type: 'item',
						url: '/account-summary-report',
						exact: true
					}
				]
			},
			{
				exact: true,
				id: 'EmailInbox',
				title: 'Email Inbox',
				translate: 'Email Inbox',
				type: 'item',
				icon: 'inbox',
				url: '/apps/email-inbox'
			},
			{
				exact: true,
				id: 'emailCampaigns',
				title: 'Email Campaign',
				translate: 'Email Campaign',
				type: 'item',
				icon: 'email',
				url: '/email/campaigns'
			},
			{
				id: 'Call Center',
				title: 'Call Center',
				translate: 'Call Center',
				type: 'collapse',
				icon: 'phone_in_talk',
				children: [
					{
						id: 'Dialer',
						title: 'Dialer',
						type: 'item',
						url: '/apps/callcenter/dialer',
						exact: true
					},
					{
						id: 'Reports',
						title: 'Reports',
						type: 'item',
						url: '/apps/callcenter/reports',
						exact: true
					},
					{
						id: 'Tickets',
						title: 'Tickets',
						type: 'item',
						url: '/apps/callcenter/tickets',
						exact: true
					},
					{
						id: 'Agent Logs',
						title: 'Agent Logs',
						type: 'item',
						url: '/apps/callcenter/agent/logs',
						exact: true
					}
				]
			},
			{
				exact: true,
				id: 'alCall',
				title: 'AI Call',
				translate: 'AI Call',
				type: 'item',
				image: '/assets/images/icons/Sidebar/Bot.png',
				url: '/ai/calls'
			},
			{
				exact: true,
				id: 'voicePortal',
				title: 'Voice Portal',
				translate: 'Voice Portal',
				type: 'item',
				icon: 'phone',
				url: '/voice-portal'
			},
			{
				id: 'Contact Book',
				title: 'Contact Book',
				translate: 'Contact Book',
				type: 'item',
				image: '/assets/images/icons/Sidebar/contact.png',
				url: '/apps/contacts/all',
				exact: true
			},
			{
				id: 'ChatBot',
				title: 'ChatBot',
				translate: 'ChatBot',
				type: 'collapse',
				image: '/assets/images/icons/Sidebar/Bot.png',
				children: [
					{
						id: 'ChatBot',
						title: 'Bot',
						type: 'item',
						url: '/adminchatbot',
						exact: true
					},
					{
						id: 'ChatBotAnalytics',
						title: 'ChatBot Analytics',
						type: 'item',
						url: '/chatbot/analytics',
						exact: true
					},
					{
						id: 'CallChatBot',
						title: 'Call ChatBot',
						type: 'item',
						url: '/chatbot/call',
						exact: true
					}
				]
			},

			{
				id: 'Info Collection',
				title: 'Info Collection',
				translate: 'Info Collection',
				type: 'item',
				icon: 'contact_phone',
				url: '/ContactInformationCollection',
				exact: true
			},
			{
				id: 'Reports',
				title: 'Reports',
				translate: 'Reports',
				type: 'collapse',
				image: '/assets/images/icons/Sidebar/report.png',
				children: [
					{
						id: 'Agent_Avg_Time',
						title: 'Agent Avg Time',
						type: 'item',
						url: '/reports/agent-average-time',
						exact: true
					},
					{
						id: 'Monthly Active Users',
						title: 'Monthly Active Users',
						translate: 'Monthly Active Users',
						type: 'item',
						url: '/report/monthly-active-users',
						exact: true
					},
					{
						id: 'Chat',
						title: 'Chat',
						type: 'item',
						url: '/report/chat',
						exact: true
					},
					{
						id: 'Template Analytics',
						title: 'Template Analytics',
						type: 'item',
						url: '/reports/template-analytics',
						exact: true
					},
					{
						id: 'Messages',
						title: 'Messages',
						translate: 'Messages',
						type: 'item',
						url: '/apps/messages',
						exact: true
					},
					{
						id: 'Template Summary',
						title: 'Template Summary',
						translate: 'Template Summary',
						type: 'item',
						url: '/reports/template-summary',
						exact: true
					},
					{
						id: 'Sub_Account',
						title: 'Sub Account',
						translate: 'Sub Account',
						type: 'item',
						url: '/report/sub-account-report',
						exact: true
					},
					{
						id: 'Agent',
						title: 'Agent',
						type: 'item',
						url: '/report/agent-report',
						exact: true
					},
					{
						id: 'Survey_Report_Feedback',
						title: 'Customer Feedback',
						type: 'item',
						url: '/report/surveyReport',
						exact: true
					},
					{
						id: 'Survey_Report_Journey',
						title: 'Customer Journey',
						type: 'item',
						url: '/report/customerJourney',
						exact: true
					},
					{
						id: 'Average Handling Time',
						title: 'Average Handling Time',
						translate: 'Average Handling Time',
						type: 'item',
						url: '/apps/aht',
						exact: true
					},
					{
						id: 'Service Levels',
						title: 'Service Levels',
						translate: 'Service Levels',
						type: 'item',
						url: '/apps/serviceLevel',
						exact: true
					},
					{
						id: 'Session Timeout Summary',
						title: 'Session Timeout Summary',
						translate: 'Session Timeout Summary',
						type: 'item',
						url: '/reports/session-ends',
						exact: true
					},
					{
						id: 'Hourly Chat Logs',
						title: 'Hourly Chat Logs',
						translate: 'Hourly Chat Logs',
						type: 'item',
						url: '/report/chat-hourly',
						exact: true
					},
					{
						id: 'Segments',
						title: 'Segments',
						translate: 'Segments',
						type: 'item',
						url: '/reports/segments',
						exact: true
					},
					{
						id: 'Chatbot Information',
						title: 'Chatbot Information',
						translate: 'Chatbot Information',
						type: 'item',
						url: '/report/chatbot-Information-oral',
						exact: true
					},
					{
						id: 'Shell Customer',
						title: 'Shell Customer',
						translate: 'Shell Customer',
						type: 'item',
						url: '/report/shell-customer',
						exact: true
					},
					{
						id: 'Lemon Max Customer',
						title: 'Lemon Max Customer',
						translate: 'Lemon Max Customer',
						type: 'item',
						url: '/report/Lemonmax-customer',
						exact: true
					},
					//OTP Logs Url Created
					{
						id: 'Otp_Logs',
						title: 'Otp Logs',
						type: 'item',
						url: '/apps/otp-logs',
						exact: true
					}
				]
			},
			{
				id: 'SMS',
				title: 'SMS',
				translate: 'SMS',
				type: 'collapse',
				image: '/assets/images/icons/Sidebar/sms.png',
				children: [
					{
						id: 'Send',
						title: 'Send',
						translate: 'Send',
						type: 'item',
						url: '/sms/send',
						exact: true
					},
					{
						id: 'Report',
						title: 'Report',
						translate: 'Report',
						type: 'item',
						url: '/sms-report',
						exact: true
					},
					{
						id: 'Fail Over Template',
						title: 'Fail Over Template',
						translate: 'Fail Over Template',
						type: 'item',
						url: '/sms/template',
						exact: true
					}
				]
			},
			{
				exact: true,
				id: 'channels',
				title: 'Channels',
				translate: 'Channels',
				type: 'item',
				image: '/assets/images/icons/Sidebar/channels.png',
				url: '/channels'
			},
			{
				exact: true,
				id: 'locationUpdate',
				title: 'Location Update',
				translate: 'Location Update',
				type: 'item',
				image: '/assets/images/icons/Sidebar/location.png',
				url: '/apps/nearest-location'
			},
			{
				id: 'Settings',
				title: 'Settings',
				translate: 'Settings',
				type: 'collapse',
				image: '/assets/images/icons/Sidebar/setting.png',
				children: [
					{
						id: 'AssignSystemPermissions',
						title: 'System Permissions',
						type: 'item',
						url: '/apps/system-permissions',
						exact: true
					},
					{
						id: 'Canned Replies',
						title: 'Canned Replies',
						type: 'item',
						url: '/apps/canned-messages',
						exact: true
					},
					{
						id: 'number',
						title: 'Number',
						type: 'item',
						url: '/apps/number',
						exact: true
					},
					{
						id: 'checkNumber',
						title: 'Check Number',
						type: 'item',
						url: '/apps/check-number',
						exact: true
					},
					{
						id: 'clearNumber',
						title: 'Clear Number',
						type: 'item',
						url: '/apps/clear-number',
						exact: true
					},
					{
						id: 'webhook',
						title: 'Webhook',
						type: 'item',
						url: '/apps/client-webhook',
						exact: true
					},
					{
						id: 'blacklistToken',
						title: 'Blacklist Token',
						type: 'item',
						url: '/apps/blacklist-token',
						exact: true
					},
					{
						id: 'ipWhitelist',
						title: 'IP Whitelist',
						type: 'item',
						url: '/apps/ip-whitelist',
						exact: true
					},
					{
						id: 'session',
						title: 'Session Timeout',
						type: 'item',
						url: '/apps/sessionMessage',
						exact: true
					},
					{
						id: 'sessionsmau',
						title: 'Sessions Mau',
						type: 'item',
						url: '/apps/sessions-mau',
						exact: true
					},
					// {
					// 	id: 'Role',
					// 	title: 'Assign Roles',
					// 	type: 'item',
					// 	url: '/apps/roles',
					// 	exact: true
					// },

					//Account Limit Page
					{
						id: 'Account Limit',
						title: 'Account Limit',
						type: 'item',
						url: '/apps/account-limits',
						exact: true
					},
					// {
					// 	id: 'Permissions',
					// 	title: 'Assign Permissions',
					// 	type: 'item',
					// 	url: '/apps/permissions',
					// 	exact: true
					// },
					{
						id: 'swichPaymentConfiguration',
						title: 'Swich Payment Configuration',
						type: 'item',
						url: '/apps/swich-payment-configuration',
						exact: true
					},
					{
						id: 'Users',
						title: 'Users',
						type: 'item',
						url: '/apps/users',
						exact: true
					},
					{
						id: 'Agent Template Messages',
						title: 'Agent Template Messages',
						type: 'item',
						url: '/templateMessage-individual-user',
						exact: true
					},
					{
						id: 'Segments',
						title: 'Segments',
						type: 'item',
						url: '/apps/admin-segments',
						exact: true
					},
					{
						id: 'Labels',
						title: 'Labels',
						type: 'item',
						url: '/apps/labels',
						exact: true
					},
					{
						id: 'dynamicBanner',
						title: 'Dynamic Banner',
						type: 'item',
						url: '/apps/dynamic-banner',
						exact: true
					},
					{
						id: 'Reminder Messages',
						title: 'Reminder Messages',
						type: 'item',
						url: '/admin-reminderMessage',
						exact: true
					},
					{
						id: 'Flag',
						title: 'Flag',
						type: 'item',
						url: '/apps/flag',
						exact: true
					},
					{
						id: 'Country Based Routing',
						title: 'Country Based Routing',
						type: 'item',
						url: '/country-based-routing',
						exact: true
					},
					{
						id: 'AI Call Providers',
						title: 'AI Call Providers',
						type: 'item',
						url: '/apps/ai-call-providers',
						exact: true
					}
				]
			},
			{
				exact: true,
				id: 'billing',
				title: 'Billing',
				translate: 'Billing',
				type: 'item',
				icon: 'receipt',
				url: '/apps/billing'
			},
			{
				exact: true,
				id: 'currentCampaigns',
				title: 'Current Campaigns',
				translate: 'Current Campaigns',
				type: 'item',
				icon: 'message',
				url: '/apps/current-campaigns'
			},
			{
				id: 'OTP',
				title: 'OTP',
				translate: 'OTP',
				type: 'collapse',
				icon: 'code',
				children: [
					{
						id: 'Otp Providers',
						title: 'Otp Providers',
						type: 'item',
						url: '/apps/otp-providers',
						exact: true
					},
					{
						id: 'Otp Users',
						title: 'Otp Users',
						type: 'item',
						url: '/apps/otp-users',
						exact: true
					}
				]
			},
			{
				id: 'FBCatalogues',
				title: 'Facebook Catalogue',
				translate: 'Facebook Catalogue',
				type: 'item',
				image: '/assets/images/icons/Sidebar/catalogue.png',
				url: '/fb-catalogues-menu',
				exact: true
			},
			{
				exact: true,
				id: 'saChannel',
				title: 'Channels',
				translate: 'Channels',
				type: 'item',
				image: '/assets/images/icons/Sidebar/channels.png',
				url: '/sa/channels'
			},
			{
				id: 'ordify',
				title: 'Ordify',
				translate: 'Ordify',
				type: 'collapse',
				icon: 'shopping_cart',
				children: [
					{
						id: 'ordifyConnect',
						title: 'Connect',
						translate: 'Connect',
						type: 'item',
						url: '/apps/ordify',
						exact: true
					},
					{
						id: 'ordifyDashboard',
						title: 'Dashboard',
						translate: 'Dashboard',
						type: 'item',
						url: '/apps/ordify/dashboard',
						exact: true
					},
					{
						id: 'ordifyPreOrder',
						title: 'Pre-Order Report',
						translate: 'Pre-Order Report',
						type: 'item',
						url: '/apps/ordify/reports/pre-order',
						exact: true
					},
					{
						id: 'ordifyPostOrder',
						title: 'Post-Order Report',
						translate: 'Post-Order Report',
						type: 'item',
						url: '/apps/ordify/reports/post-order',
						exact: true
					},
					{
						id: 'ordifyOrderSummary',
						title: 'Order Summary',
						translate: 'Order Summary',
						type: 'item',
						url: '/apps/ordify/summary/order-summary',
						exact: true
					},
					{
						id: 'ordifyChannelSummary',
						title: 'Channel Summary',
						translate: 'Channel Summary',
						type: 'item',
						url: '/apps/ordify/summary/channel-summary',
						exact: true
					},
					{
						id: 'ordifyTemplateSummary',
						title: 'Template Summary',
						translate: 'Template Summary',
						type: 'item',
						url: '/apps/ordify/summary/template-summary',
						exact: true
					},
					{
						id: 'ordifyUsers',
						title: 'Users',
						translate: 'Users',
						type: 'item',
						url: '/apps/ordify/users',
						exact: true
					}
				]
			}
			// {
			// 	exact: true,
			// 	id: 'campaignApprovals',
			// 	title: 'Campaign Approvals',
			// 	translate: 'Campaign Approvals',
			// 	type: 'item',
			// 	icon: 'fact_check',
			// 	url: '/apps/campaign-approvals'
			// }
		]
	}
];
export default navigation;
